// import React from "react";

// export default function SliderComponent({ setShowLogin, isMobile }) {
//     function handleSignInClick() {
//         setShowLogin(true);
//     }

//     // Inline style object using your provided styles
//     const signInButton = {
//         // backgroundColor: "#ee6521",
//         color: "white",
//         fontSize: isMobile ? "14px" : "18px",
//         // fontFamily: "Lato, sans-serif",
//         fontWeight: "bold",
//         // borderRadius: "16px",
//         // width: isMobile ? "80px" : "90px",
//         // height: isMobile ? "36px" : "40px",
//         // border: "none",
//         cursor: "pointer",
//         marginLeft: isMobile ? "auto" : "0",
//     };

//     return <p onClick={handleSignInClick} style={signInButton}>SIGN IN</p>;
// }




import React from "react";

export default function SliderComponent({ setShowLogin, isMobile, isLoggedIn }) {
    function handleSignInClick() {
        setShowLogin(true);
    }

    const signInButton = {
        color: isMobile ? "black" : "#ee6521",        // ✔ Mobile → Black text
        border: isMobile ? "1px solid black" : "#ee6521", // ✔ Mobile → Border
        padding: isMobile ? "6px 12px" : "0px",     // Extra spacing on mobile
        borderRadius: isMobile ? "6px" : "0px",
        fontSize: isMobile ? "14px" : "18px",
        fontWeight: "bold",
        cursor: "pointer",
        marginLeft: isMobile ? "auto" : "0",
    };

    if (isLoggedIn) {
        return null;
    }

    return <p onClick={handleSignInClick} style={signInButton}>SIGN IN</p>;
}


